module.exports = __webpack_public_path__ + "img/teacherBackgorund1.e07fd353.png";